'use strict';

angular.module('upAttributes').service('LeadSourceAttributes', [
	'FilterType',
	'DisplayType',
	function (FilterType, DisplayType) {
		return function () {
			var attributes = {
				id: {
					title: 'default.id',
					field: 'id',
					type: FilterType.Number,
					displayType: DisplayType.Number,
					groupable: false,
					sortable: false,
					selectableColumn: false,
					filterable: false
				},
				name: {
					title: 'default.name',
					field: 'name'
				}
			};
			return {
				getAll: function () {
					return attributes;
				},
				attr: attributes,
				keys: {
					ID: 'id',
					NAME: 'namn'
				}
			};
		};
	}
]);
